<template>
    <div class="pdf-wrap">
        <vue-pdf-app :pdf="pdfUrl" style="height: 100%;" />
    </div>
</template>

<script setup>
import VuePdfApp from "vue3-pdf-app";
import "vue3-pdf-app/dist/icons/main.css";
defineProps({ pdfUrl: String });
</script>

<style scoped>
.pdf-wrap {
    width: 100%;
    height: 100%
}
</style>